/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        type: "constructor",
        inputs: [
            {
                name: "_leverage",
                type: "address",
                internalType: "contract ERC20Leverage",
            },
        ],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "adapter",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "contract BaseALMAdapter",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "leverage",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "contract ERC20Leverage",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "mint",
        inputs: [
            {
                name: "depositParams",
                type: "tuple",
                internalType: "struct BaseALMAdapter.DepositParams",
                components: [
                    {
                        name: "vault",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "amount0Desired",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "amount1Desired",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "amount0Min",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "amount1Min",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "receiver",
                        type: "address",
                        internalType: "address",
                    },
                ],
            },
            {
                name: "initParams",
                type: "tuple",
                internalType: "struct BaseERC20LeveragedPosition.PositionInitParams",
                components: [
                    {
                        name: "lpToken",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "lpAmount",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "tokenToBorrow",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "amountToBorrow",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "assetConverter",
                        type: "address",
                        internalType: "contract IAssetConverter",
                    },
                    {
                        name: "maxSwapSlippage",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "owner",
                        type: "address",
                        internalType: "address",
                    },
                ],
            },
        ],
        outputs: [
            {
                name: "position",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "nonpayable",
    },
    {
        type: "error",
        name: "AddressEmptyCode",
        inputs: [
            {
                name: "target",
                type: "address",
                internalType: "address",
            },
        ],
    },
    {
        type: "error",
        name: "AddressInsufficientBalance",
        inputs: [
            {
                name: "account",
                type: "address",
                internalType: "address",
            },
        ],
    },
    {
        type: "error",
        name: "FailedInnerCall",
        inputs: [],
    },
    {
        type: "error",
        name: "SafeERC20FailedOperation",
        inputs: [
            {
                name: "token",
                type: "address",
                internalType: "address",
            },
        ],
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class ALMCreateAndLeverage__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_leverage, overrides) {
        return super.deploy(_leverage, overrides || {});
    }
    getDeployTransaction(_leverage, overrides) {
        return super.getDeployTransaction(_leverage, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
ALMCreateAndLeverage__factory.bytecode = _bytecode;
ALMCreateAndLeverage__factory.abi = _abi;
//# sourceMappingURL=ALMCreateAndLeverage__factory.js.map